<template>
  <div class="header-cta-teacher">
    <AppButton
      :tag="tag"
      :text="text"
      v-bind="link"
      :class="classBtn"
    >
      <template #icon-right>
        <AppIcon
          name="human-male-board"
          size="medium"
        />
      </template>
    </AppButton>
  </div>
</template>

<script>
import AppButton from '@library/element/button'
import AppIcon from '@library/element/icon'
export default {
  name: 'HeaderCtaTeacher',
  components: { AppIcon, AppButton },
  inject: ['allProps'],
  computed: {
    auth () {
      return this.allProps.data.auth
    },
    commonLink () {
      return {
        startTeaching: this.allProps.data.linksHeaderTop.startTeaching,
        dashboardTeacher: this.allProps.data.linksHeaderTop.dashboardTeacher
      }
    },
    tag () {
      return 'a'
    },
    text () {
      return this.auth.user.teacher.status === 'approved' ? this.$t('menu.dashboard_teacher') : this.$t('menu.register_teacher')
    },
    classBtn () {
      return this.auth.user.teacher.status === 'approved' ? '' : 'startTeachingClick'
    },
    link () {
      return this.auth.user.teacher.status === 'approved' ? this.commonLink.dashboardTeacher.attrTag : this.commonLink.startTeaching.attrTag
    }
  }
}
</script>
